<template>
	<!-- content -->
	<div id="content" class="content goods">
		<div class="container">
			<div class="detail-title">
				<div class="inner">
					<div class="thumb-box" v-if="goodsVO.thumbnail !== null" :style="'background-image:url(' + APIs.SHOP_FILE_SHOW + goodsVO.thumbIdx + ');'"></div>
					<div class="thumb-box" v-else style="background-image:url(public/ssflex/assets/hws-images/icons8-color-64.png);"></div>
					<div class="text-box">
						<div class="cate bedge-line">
							<span class="prim">{{ goodsVO.cateVO.codeName }}</span>
							<span class="sec" v-if="goodsVO.isImport">추천상품</span>
						</div>
						<h3 class="tit">{{ goodsVO.title }}</h3>
						<div class="info">
							<div class="info-row">
								<strong>적립 포인트</strong>
								<div>{{ goodsVO.savePoint }}</div>
							</div>
							<div class="info-row">
								<strong>할인율</strong>
								<div>{{ goodsVO.eventPer }}%</div>
							</div>
						</div>
						<div class="price" style="float: left;">
							{{ ( goodsVO.basePrice * count ) | currency }} <span class="unit">원</span>
<!--							{{ goodsVO.basePrice * count | currency }} <span class="unit">원</span>-->
						</div>
						<div style="text-decoration : line-through; float: left; color: silver;" class="sale-price" v-if="goodsVO.eventPer > 0">
							{{ Math.floor(-1 * (( goodsVO.basePrice * count ) / ((goodsVO.eventPer / 100) - 1))) | currency }} <span class="unit">원</span>
						</div>
						<div class="text-vat" v-if="goodsVO.isVat">
							* 부가세 포함
						</div>
						<div style="float: right;" v-if="goodsVO.selling && goodsVO.stock">
							<span class="btns-added"></span>
							<input type="button" value="-" class="countMinusTempCss" @click="count > 1 ? --count : count">
<!--							<input type="number" class="inpTempCss" id="quantity" name="quantity" title="수량" size="4" oninput="this.value = this.value.replaceAll(/\D/g, '');" step="1" v-model="count">-->
							<input type="number" class="inpTempCss" id="quantity" name="quantity" title="수량" size="4" min="1" oninput="this.value = this.value.replaceAll(/\D/g, '');" step="1" v-model="count">
							<input type="button" value="+" class="countPlusTempCss" @click="++count">

							<!-- 초기화 -->
							<a href="javascript:;" class="countBtn m-l-5 p-t-4" style="text-align: center;" @click="count = 1"><i class="fas fa-sm fa-redo align-bottom"></i></a>

						</div>

						<!-- 정상 구매 버튼 -->
						<div class="btn-wrap" v-if="goodsVO.selling && goodsVO.stock">
							<!-- 결제하기-->
							<a class="btn-purchase" @click="goPurchase">결제하기</a>
							<!-- 장바구니-->
							<a href="javascript:;" class="btn-apply" @click="goCart">장바구니</a>
							<!-- 찜-->
							<a class="btn-like" v-if="isLogin()" type="button" :id="'eWish-'+goodsVO.gid" :data-gid="goodsVO.gid" @click="setWish"><i class="ico-heart"></i>{{ wishCount | currency }}</a>
							<a class="btn-like" v-else-if="!isLogin()" type="button" @click="loginInfo"><i class="ico-heart"></i>{{ wishCount | currency }}</a>
						</div>

						<!-- 판매중지 or 재고없음 -->
						<div class="btn-wrap" v-else>
							<template v-if="!goodsVO.selling">
								판매중지된 상품입니다.
							</template>
							<template v-if="!goodsVO.stock">
								구매가능한 재고가 없습니다.
							</template>

							<!-- 찜-->
							<a class="btn-like" v-if="isLogin()" type="button" :id="'eWish-'+goodsVO.gid" :data-gid="goodsVO.gid" @click="setWish"><i class="ico-heart"></i>{{ wishCount | currency }}</a>
							<a class="btn-like" v-else-if="!isLogin()" type="button" @click="loginInfo"><i class="ico-heart"></i>{{ wishCount | currency }}</a>
						</div>

					</div>
				</div>
			</div>
			<div class="detail-content">
<!--				<div class="inner" style="word-break: break-all;" v-html="goodsVO.contentVO.contentHtml"></div>-->
				<html-open :html-code="goodsVO.contentVO.contentHtml"></html-open>
			</div>
			<div class="btn-area">
				<a href="javascript:;" class="btn-listgo" v-if="prevAddress !== -1" @click="doCancel">목록으로</a>
				<a href="javascript:;" class="btn-listgo" v-else @click="doCancel">뒤로가기</a>
			</div>
		</div>
	</div>
</template>

<script>
import wish from "@/commons/mixins/wish"
import HtmlOpen from "@/components/display/htmlOpen";

export default {
	name: "goodsDetail",
	components: {HtmlOpen},
	mixins: [
		wish
	],
	data() {
		var prevAddress;
		return {
			goodsVO: {},
			prevAddress,
			count: 1,
		}
	},
	created() {
		this.getGoodsOne()
	},
	mounted() {
		this.prevAddress = (document.referrer).indexOf('design_auto_app');
	},
	methods: {
		getGoodsOne() {
			console.log('getGoodsOne')
			var gid = this.$route.params.gid

			this.$eventBus.$emit("startProgress", 1)
			this.axiosCaller.get(this, this.APIs.SHOP_GOODS + "/" + gid, {}, (res) => {
				var result = res.data
				this.goodsVO = result.goods
				this.$eventBus.$emit("doneProgress", 1)

				console.log('goodsVO : ', result.goods)
			})
		},

		async goCart() {

			if ( !await this.requireLogin(this) ) {
				return
			}

			var gid = this.$route.params.gid;
			var userId = this.getSessionProc().coEmailId;
			var count = this.count;

			this.$eventBus.$emit("startProgress", 1)
			this.axiosCaller.post(this, this.APIs.CART + "/setCart", {
				gid: gid,
				coEmailId: userId,
				count: count,
			}, (res) => {
				var result = res.data
				if (result.status === "ok") {
					this.swalUtils.fire("장바구니로 이동하시겠습니까?", "선택하신 상품이\r\n장바구니에 추가되었습니다.", "info", true)
							.then((result) => {
								if (result.isConfirmed) { location.href = "/app/shop/cartList" }
							})
				} else {
					this.swalUtils.fire("비정상적인 접근", "메인으로 이동합니다.", "error", true, true)
							.then((result) => {
								console.log( result )
							});
				}
			})
		},

		loginInfo() {
			this.swalUtils.fire("로그인 후 사용가능합니다.",  "로그인 화면으로 이동합니다.", "info", true)
					.then((result) => {
						let pathname = location.pathname;
						let referrer = ("?referrer=" + encodeURIComponent( pathname ));
						if (result.isConfirmed) { location.href = "/member/login" + referrer }
					})
		},

		doCancel() {
			history.back();
			return;
		},

		async goPurchase() {

			if ( !await this.requireLogin(this) ) {
				return
			}

			this.swalUtils.fire("선택하신 상품을\r\n구매하시겠습니까?", "", "info", true)
					.then((result) => {
						this.$eventBus.$emit("startProgress", 1)
						if (result.isConfirmed) {
							location.href = "/app/shop/order_info?gidx="+this.gid+"&count="+this.count
						//
						// 	var gid = this.$route.params.gid
						// 	var userId = this.getSessionProc().coEmailId;
						// 	var count = this.count;
						// 	this.axiosCaller.post(this, this.APIs.CART + "/setCart", {
						// 		gid: gid,
						// 		coEmailId: userId,
						// 		count: count
						// 	}, (res) => {
						// 		var result = res.data
						// 		if (result.status === "ok") {
						// 			location.href = "/app/shop/order_info?gidx="+this.gid+"&count="+this.count
						// 		} else {
						// 			this.swalUtils.gritter("Error", result.msg, "error")
						// 					.then(() => {
						// 						location.href = document.referrer
						// 					})
						// 		}
						// 	})
						//
						}
					})
		}

	},
	watch: {}
}
</script>

<style scoped>
.btn-purchase {
	cursor: pointer;
}
.btn-wrap .btn-like i {
	display: inline-block;
	width: 16px;
	height: 16px;
	margin-right: 8px;
	background: url(/ssflex/assets/img/common/ico_heart_prim.svg) no-repeat center/16px;
	vertical-align: middle;
}
.btn-wrap .btn-like.active i {
	background: url(/ssflex/assets/img/common/ico_heart_fill_prim.svg) no-repeat center/16px;
}
.sale-price {
	margin-left: 6px;
	margin-top: 12px;
	margin-bottom: 24px;
	font-size: 16px;
	font-weight: 900;
}
.text-vat {
	display: inline-block;
	margin-left: 6px;
	margin-top: 16px;
	margin-bottom: 24px;
	font-size: 12px;
	/*color: red;*/
}
/* goodsDetail btn */
.goods .detail-title .btn-wrap .btn-purchase {
	width: 100%;
	margin-right: 16px;
	background-color: var(--secondary);
	vertical-align: top;
	color: #fff;
	margin-bottom: 2%;
}
.inpTempCss,
.countMinusTempCss,
.countPlusTempCss {
	margin-bottom: 48px;
}
.countPlusTempCss,
.countMinusTempCss {
	position: relative;
	float: left;
	width: 28px;
	height: 28px;
	background: #fff;
	border: 1px solid var(--gray100);
	border-radius: 14px;
	font-size: 0;
	color: transparent;
}
.countBtn {
	position: relative;
	float: left;
	width: 28px;
	height: 28px;
	background: #fff;
	border: 1px solid var(--gray100);
	border-radius: 14px;
	/*font-size: 0;*/
	/*color: transparent;*/
}
.countPlusTempCss {
	background: url(/ssflex/assets/img/common/ico_add.svg) no-repeat center/16px;
}
.countMinusTempCss {
	background: url(/ssflex/assets/img/common/ico_minus.svg) no-repeat center/16px;
}
.inpTempCss {
	float: left;
	width: 40px;
	height: 28px;
	border: 0;
	text-align: center;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
	-webkit-appearance: none;
	margin: 0;
}
input[type=number] {
	-moz-appearance: textfield;
}
</style>
